import React, { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import StepTable from "./StepTable";
import useAxios from "axios-hooks";
import DeleteStepModal from "./DeleteStepModal";
import { Spinner, Toggle } from "@fluentui/react";
import CloneStepModal from "./CloneStepModal";
import { useBoolean } from "@fluentui/react-hooks";

const StepList = () => {
    const [selectedStep, setSelectedStep] = useState();
    const history = useHistory();
    let { url } = useRouteMatch();

    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);
    const [showCloneModal, { toggle: toggleCloneModal }] = useBoolean(false);

    const [{ data: steps, loading }, refetch] = useAxios("courses/crs-steps");
    const [{ data }, submitForm] = useAxios(
        { url: `courses/crs-step-clone` },
        { manual: true }
      );

    if (loading)
        return <Spinner className="absolute-center" label="Loading Course..." />;

    return (
        <>
            <StepTable
                steps={steps}
                setSelectedStep={setSelectedStep}
                createOnClick={() => history.push(`${url}/edit/`)}
                cloneOnClick={async (id) => {
                    const result = await submitForm({
                        method: "post",
                        url: `courses/crs-step-clone/${id}`,
                      });
                      
                      if (!result.isAxiosError) {
                        history.push(`${url}/edit/${result.data}`);
                      } else {
                        console.log("An error occurred while saving the step.");
                      }
                }}
                deleteOnClick={(item) => {
                    setSelectedStep(item);
                    toggleDeleteModal();
                }}
                editOnClick={(id) => history.push(`${url}/edit/${id}`)}
                refetch={refetch}
                loading={loading}
            />
            <CloneStepModal
                stepId={selectedStep?.crsStepID}
                showModal={showCloneModal}
                toggleShowModal={toggleCloneModal}
            />
            <DeleteStepModal
                stepId={selectedStep?.crsStepID}
                stepTitle={selectedStep?.crsStepTitle}
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
            />
        </>
    );
};

export default StepList;
